import React,{useMemo,useState,useEffect} from "react";
import {
Layout,
Menu,
Drawer,
Button,
Typography
} from "antd";
import { 
  Box,
  Grid,
  IconButton
} from "@mui/material";
import { FaArrowRight } from "react-icons/fa";
import { FileAddOutlined } from "@ant-design/icons";
import TeacherAnalytics from "./TeacherAnalytics";

import {
MenuFoldOutlined,
MenuUnfoldOutlined,
DashboardOutlined,
BarChartOutlined,
CalendarOutlined,
TeamOutlined,
UserOutlined,
ReadOutlined,
DollarOutlined,
SettingOutlined
} from "@ant-design/icons";

import {
  FaClipboardList,
  FaMoneyBill,
  FaReceipt,
  FaGraduationCap,
  FaChalkboardTeacher
} from "react-icons/fa";

import {motion} from "framer-motion";
import Darkmode from "../NewDashboard/Darkmode/Darkmode";

import NotificationIcon from "../components/ChatApp/NotificationIcon";
import LessonPlan from "../pages/Teachers/LessonPlan";
import ViewLessonPlan from "../pages/Teachers/ViewLessonPlan";
import Test from "../pages/Teachers/Test";
import TestPraint from "../pages/Teachers/TestPraint";
// import ProfileImage from "../NewDashboard/ProfileImage";
import ProfileImageTeacher from "../NewDashboard/ProfileImageTeacher";

import TestAttachment from "./TestAttachment";
import AttendanceRecord from "../pages/Attendance/AttendanceRecord";
import AttendanceData from "../pages/Attendance/AttendanceData";
import AssignmentView from "../pages/Teachers/AssignmentView";
import PostAssignment from "../pages/Teachers/PostAssignment";
import GradeDistribution from "../pages/Reportcard/GradeDistribution";
import Notification from "../NewDashboard/Notification/Notification";
import Complaint from "./Complaint";
import PostNotes from "../pages/Teachers/PostNotes";
import { Link } from 'react-router-dom';


import CurriculumTeacherWorkspace from "../NewDashboard/CurriculumTeacherWorkspace";
import CurriculumTopicDetails from "../NewDashboard/CurriculumTopicDetails";
import CurriculumLessonEditor from "../NewDashboard/CurriculumLessonEditor";








import logo from "./savationChristLogo.png";

const {Header,Sider,Content}=Layout;
const {Title,Text}=Typography;


const TeacherDashboard =()=>{

const [collapsed,setCollapsed]=useState(false);
const [drawerOpen,setDrawerOpen]=useState(false);
const [darkMode,setDarkMode]=useState(false);
const [activePage,setActivePage]=useState("quicklinks");
const [visibleIndex,setVisibleIndex]=useState(0);
const [openAttachment, setOpenAttachment] = useState(false);
const [openNotes,setOpenNotes]=useState(false);



const [isMobile,setIsMobile]=useState(window.innerWidth < 768);

useEffect(()=>{

const handleResize=()=>{
setIsMobile(window.innerWidth < 768);
};

window.addEventListener("resize",handleResize);

return()=>window.removeEventListener("resize",handleResize);

},[]);


useEffect(()=>{
const style=document.createElement("style");

style.innerHTML=`
::-webkit-scrollbar{
width:9px;
height:3px;
}
::-webkit-scrollbar-track{
background:transparent;
}
::-webkit-scrollbar-thumb{
background:#800000;
border-radius:10px;
}
::-webkit-scrollbar-thumb:hover{
background:#5a0000;
}
`;

document.head.appendChild(style);

return()=>document.head.removeChild(style);

},[]);


const theme=useMemo(()=>({
darkMode,

background:darkMode?"#0f172a":"#f5f7fb",
sidebar:darkMode?"#111827":"#ffffff",
header:darkMode?"#111827":"#ffffff",
card:darkMode?"#1e293b":"#ffffff",
inputBackground:darkMode?"#1e293b":"#ffffff",

text:darkMode?"#ffffff":"#172033",
secondary:darkMode?"#cbd5e1":"#64748b",

border:darkMode?"#334155":"#e5e7eb",

primary:"#2563eb"

}),[darkMode]);



const menuItems=[
{
key:"quicklinks",
icon:<DashboardOutlined/>,
label:"Dashboard"
},

{
key:"gradedistribution",
icon:<FaChalkboardTeacher />, 
label:"Grades Input"
},

// AI LESSON PLAN GENERATION

{
key:"curriculumteacherworkspace",
icon:<FaChalkboardTeacher />, 
label:"Curriculum Teacher Workspace"
},

{
key:"curriculumtopicdetails",
icon:<FaChalkboardTeacher />, 
label:"Curriculum Topic Details"
},

{
key:"curriculumlessoneditor",
icon:<FaChalkboardTeacher />, 
label:"Curriculum Lesson Editor"
},

// END


{
key:"lessonplan",
icon:<FaChalkboardTeacher />, 
label:"Lesson Plan"
},

{
key:"viewlessonplan",
icon:<FaChalkboardTeacher />,
label:"View Lesson Plan"
},



{
key:"assignmentview",
icon:<FaClipboardList />,
label:"Assignment View"
},

{
key:"test",
icon:<FaClipboardList />,
label:"Tests"
},

{
key:"teachertests",
icon:<FaClipboardList />,
label:"Teacher Tests"
},

{
key:"complaint",
icon:<FaClipboardList />,
label:"Complaints"
},



];

const quickLinks=[
{
value:"lessonplan",
label:"Lesson Plan"
},
{
value:"viewlessonplan",
label:"View Lesson Plan"
},
{
value:"teacherassignments",
label:"Post Assignment"
},
{
value:"assignmentview",
label:"Assignment View"
},
{
value:"test",
label:"Create Test"
},
{
value:"teachertests",
label:"Teacher Tests"
},

{
value:"fees",
label:"Fees Balances"
},

{
value:"complaint",
label:"Complaints"
}
];

const renderPage=()=>{

switch(activePage){


case "gradedistribution":
  return <GradeDistribution theme={theme}/>; 

case "curriculumteacherworkspace":
  return <CurriculumTeacherWorkspace theme={theme}/>; 

case "curriculumtopicdetails":
  return <CurriculumTopicDetails theme={theme}/>;   

case "curriculumlessoneditor":
  return <CurriculumLessonEditor theme={theme}/>;   

case "lessonplan":
  return <LessonPlan theme={theme}/>;   

case "viewlessonplan":
  return <ViewLessonPlan theme={theme}/>;  

case "teacherassignments":
  return <PostAssignment theme={theme}/>;  

case "assignmentview":
  return <AssignmentView theme={theme}/>;  

case "test":
  return <Test theme={theme}/>;  

case "teachertests":
  return <TestPraint theme={theme}/>;  

case "complaint":
  return <Complaint theme={theme}/>;  

  

case "attendancedata":
  return <AttendanceData theme={theme}/>;  

case "attendance":
  return <AttendanceRecord theme={theme}/>;  








case "quicklinks":

const quickLinks = [
  
  { label: "Assign", value: "teacherassignments" },
  { label: "TQ", value: "test" },
  { label: "View Test", value: "teachertests" },
  { label: "Complain", value: "complaint" },
  { label: "Attendance", value: "attendance" },
  { label: "Attendance Data", value: "attendancedata" },
];

return (
<Grid container spacing={4}>
<Grid item xs={12}>
<Box
sx={{
minHeight:"220px",
borderRadius:"25px",
padding:isMobile ? "25px 15px" : "35px",
background: darkMode
? "linear-gradient(135deg,#111827,#1e293b)"
: "linear-gradient(135deg,#ffffff,#eef6ff)",
boxShadow: darkMode
? "0 15px 40px rgba(0,0,0,.35)"
: "0 15px 40px rgba(0,0,0,.08)",
border:`1px solid ${theme.border}`,
position:"relative",
overflow:"hidden"
}}
>

<Box
sx={{
position:"absolute",
width:220,
height:220,
borderRadius:"50%",
background:"linear-gradient(135deg,#2563eb,#4caf50)",
opacity:.15,
top:-80,
right:-60
}}
/>

<Box
sx={{
position:"absolute",
width:150,
height:150,
borderRadius:"50%",
background:"#034f84",
opacity:.1,
bottom:-50,
left:-40
}}
/>

<Box
sx={{
textAlign:"center",
mb:4,
position:"relative",
zIndex:2
}}
>

<Typography
variant="h4"
sx={{
fontWeight:800,
color:theme.text,
mb:1
}}
>
Teacher Dashboard
</Typography>



<Typography
sx={{
color:theme.secondary,
fontSize:15
}}
>
Quick access to your teaching tools and academic activities
</Typography>

</Box>

<Box
sx={{
display:"flex",
alignItems:"center",
justifyContent:"center",
gap:2,
position:"relative",
zIndex:2
}}
>

<IconButton
onClick={()=>
setVisibleIndex(prev=>Math.max(prev-2,0))
}
sx={{
width:45,
height:45,
background:darkMode ? "#1e40af" : "#034f84",
color:"#fff",
boxShadow:"0 8px 20px rgba(0,0,0,.2)",
"&:hover":{
background:"#4caf50",
transform:"scale(1.1)"
},
transition:"all .3s"
}}
>

<FaArrowRight
style={{
transform:"rotate(180deg)"
}}
/>

</IconButton>


<Box
sx={{
display:"flex",
gap:2,
overflow:"hidden",
width:isMobile?"70%":"auto",
justifyContent:"center"
}}
>

{
quickLinks
.slice(
visibleIndex,
visibleIndex+(isMobile?2:quickLinks.length)
)
.map((btn)=>(

<motion.div
key={btn.value}
whileHover={{
scale:1.08,
y:-5
}}
whileTap={{
scale:.95
}}
>

<Button
variant="contained"
onClick={()=>
setActivePage(btn.value)
}
sx={{
minWidth:isMobile?120:150,
height:55,
borderRadius:"18px",
background:darkMode
?
"linear-gradient(135deg,#2563eb,#1d4ed8)"
:
"linear-gradient(135deg,#034f84,#2563eb)",
color:"#fff",
fontWeight:700,
fontSize:14,
textTransform:"none",
display:"flex",
alignItems:"center",
justifyContent:"center",
boxShadow:"0 10px 25px rgba(37,99,235,.35)",
"&:hover":{
background:"linear-gradient(135deg,#4caf50,#16a34a)",
boxShadow:"0 15px 30px rgba(76,175,80,.35)"
},
transition:"all .3s ease"
}}
>

{btn.label}

</Button>

</motion.div>

))

}

</Box>


<IconButton
onClick={()=>
setVisibleIndex(prev=>
Math.min(
prev+2,
quickLinks.length-2
)
)
}
sx={{
width:45,
height:45,
background:darkMode ? "#1e40af" : "#034f84",
color:"#fff",
boxShadow:"0 8px 20px rgba(0,0,0,.2)",
"&:hover":{
background:"#4caf50",
transform:"scale(1.1)"
},
transition:"all .3s"
}}
>

<FaArrowRight/>

</IconButton>




</Box>
<br/>

<div
  style={{
    display: "flex",
    justifyContent: "center",
    marginLeft: "16px",
    gap: "8px",
  }}
>
  <Button
    type="default"
    size="small"
    onClick={(e) => {
      e.stopPropagation();
      setOpenAttachment(true);
    }}
    style={{
      height: "28px",
      padding: "0 12px",
      fontSize: "12px",
      borderRadius: "6px",
      fontWeight: 500,
      minWidth: "110px",
    }}
  >
    Test
  </Button>

  <Button
    type="primary"
    icon={<FileAddOutlined />}
    onClick={() => setOpenNotes(true)}
    style={{
      background: "#800000",
      height: "28px",
      borderRadius: "6px",
      fontWeight: 500,
    }}
  >
    Notes
  </Button>

<Link to="/chatApp" style={{ textDecoration: 'none' }}>
   <Button variant="contained">
    Chats
  </Button> 
   </Link>

</div>

</Box>



</Grid>


<TeacherAnalytics/>

</Grid>
);

}

};


const sidebar=(

<div
style={{
height:"100vh",
display:"flex",
flexDirection:"column",
background:"transparent"
}}
>

{/* Logo */}
<div
style={{
height:75,
flexShrink:0,
display:"flex",
alignItems:"center",
gap:12,
padding:"0 18px",
borderBottom:`1px solid ${theme.border}`
}}
>

<img
src={logo}
alt="logo"
style={{
width:42,
height:42,
borderRadius:12,
objectFit:"cover"
}}
/>


{!collapsed &&
<div>

<Title
level={5}
style={{
margin:0,
color:theme.text
}}
>
  Salvation In Christ School System
</Title>


<Text
style={{
fontSize:12,
color:theme.secondary
}}
>
SMS - Portal
</Text>

</div>
}

</div>



{/* Profile */}
{!collapsed &&
<div
style={{
flexShrink:0
}}
>
<ProfileImageTeacher theme={theme}/>
</div>
}




{/* ONLY MENU SCROLLS */}
<div
style={{
flex:1,
overflowY:"auto",
overflowX:"hidden"
}}
>


<Menu
mode="inline"
items={menuItems}
selectedKeys={[activePage]}
inlineCollapsed={collapsed}

onClick={({key})=>{
setActivePage(key);

if(isMobile)
setDrawerOpen(false);

}}

theme={darkMode?"dark":"light"}

style={{
background:"transparent",
border:"none"
}}
/>


</div>




{/* STATIC FOOTER */}
<div
style={{
height:55,
flexShrink:0,
display:"flex",
alignItems:"center",
padding:"0 15px",
borderTop:`1px solid ${theme.border}`,
background:theme.sidebar
}}
>

<Text
style={{
fontSize:12,
color:theme.secondary
}}
>

© 2026 Salvation In Christ School System
</Text>

</div>


</div>

);


return(

<div
style={{
position:"fixed",
top:0,
left:0,
right:0,
bottom:0,
zIndex:999,
background:theme.background,
overflow:"auto"
}}
>

<Layout
style={{
minHeight:"100vh",
background:theme.background
}}
>


{!isMobile &&

<Sider
width={260}
collapsedWidth={75}
collapsed={collapsed}

style={{
position:"fixed",
height:"100vh",
background:theme.sidebar,
borderRight:`1px solid ${theme.border}`,
overflow:"hidden"
}}
>
{sidebar}

</Sider>

}



{isMobile &&

<Drawer
open={drawerOpen}
width={260}
bodyStyle={{padding:0}}
onClose={()=>setDrawerOpen(false)}
>

{sidebar}

</Drawer>

}



<Layout
style={{
marginLeft:isMobile?0:collapsed?75:260
}}
>


<Header
style={{
height:isMobile ? 60 : 70,
padding:isMobile ? "0 8px" : "0 20px",
display:"flex",
alignItems:"center",
justifyContent:"space-between",
background:theme.header,
borderBottom:`1px solid ${theme.border}`,
position:"sticky",
top:0,
zIndex:10,
overflow:"hidden"
}}
>


<div
  style={{
    display: "flex",
    alignItems: "center",
    gap: isMobile ? 6 : 15,
    minWidth: 0,
    flex: 1,
    overflow: "hidden",
  }}
>
  <Button
    shape="circle"
    icon={
      isMobile ? (
        <MenuUnfoldOutlined />
      ) : collapsed ? (
        <MenuUnfoldOutlined />
      ) : (
        <MenuFoldOutlined />
      )
    }
    onClick={() => {
      if (isMobile) setDrawerOpen(true);
      else setCollapsed(!collapsed);
    }}
  />

  <Text
    style={{
      fontSize: isMobile ? "13px" : "20px",
      fontWeight: 800,
      color: theme.text,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      letterSpacing: isMobile ? "0px" : "0.5px",
      lineHeight: 1,
    }}
  >
    TEACHER DASHBOARD
  </Text>
</div>






<div
style={{
display:"flex",
alignItems:"center",
gap:isMobile ? 8 : 20,
flexShrink:0
}}
>




{!isMobile &&
<Darkmode
darkMode={darkMode}
setDarkMode={setDarkMode}
/>
}

{isMobile &&
<Darkmode
darkMode={darkMode}
setDarkMode={setDarkMode}
/>
}


<Notification
theme={theme}
/>


<div
style={{
width:isMobile ? 34 : 45,
height:isMobile ? 34 : 45,
overflow:"hidden",
borderRadius:"50%",
display:"flex",
alignItems:"center",
justifyContent:"center"
}}
>

<ProfileImageTeacher
theme={theme}
header
/>

</div>

</div>




</Header>



<Content
style={{
padding:20,
background:theme.background,
minHeight:"calc(100vh - 70px)",
overflowY:"auto"
}}
>


<motion.div
initial={{opacity:0,y:15}}
animate={{opacity:1,y:0}}
transition={{duration:.3}}
>

{renderPage()}

</motion.div>


</Content>


</Layout>

</Layout>


      {/* Test File Attashment */}
      <TestAttachment
    open={openAttachment}
    handleClose={() => setOpenAttachment(false)}
/>

<PostNotes

open={openNotes}

onClose={()=>setOpenNotes(false)}

/>


</div>

);

};


export default TeacherDashboard;


